import { makeEnum } from '@transcend-io/type-utils';

export const DiscoClassScanType = makeEnum({
  SchemaOnly: 'SCHEMA_ONLY',
  FullScan: 'FULL_SCAN',
  ClassificationOnly: 'CLASSIFICATION_ONLY',
});

/** Overload type */
export type DiscoClassScanType =
  (typeof DiscoClassScanType)[keyof typeof DiscoClassScanType];

export const DiscoClassScanStatus = makeEnum({
  InProgress: 'IN_PROGRESS',
  Paused: 'PAUSED',
  Complete: 'COMPLETE',
  Disconnected: 'DISCONNECTED',
  Error: 'ERROR',
  Stopped: 'STOPPED',
});

/** Overload type */
export type DiscoClassScanStatus =
  (typeof DiscoClassScanStatus)[keyof typeof DiscoClassScanStatus];

export const DiscoClassScanAction = makeEnum({
  Start: 'START',
  Pause: 'PAUSE',
  Resume: 'RESUME',
  Stop: 'STOP',
  Restart: 'RESTART',
});

/** Overload type */
export type DiscoClassScanAction =
  (typeof DiscoClassScanAction)[keyof typeof DiscoClassScanAction];

/** Supported classification browse list quick filters */
export enum ClassificationBrowseListQuickFilter {
  RecurringScansOn = 'RECURRING_SCANS_ON',
  RecurringScansOff = 'RECURRING_SCANS_OFF',
  Disconnected = 'DISCONNECTED',
  NotConfigured = 'NOT_CONFIGURED',
  Error = 'ERROR',
}

/** Status of a phase of a disco class scan */
export enum ScanPhaseStatus {
  /** The scan is in progress */
  InProgress = 'IN_PROGRESS',
  /** The scan was stopped */
  Stopped = 'STOPPED',
  /** The scan has finished running successfully */
  Complete = 'COMPLETE',
  /** The scan encountered an error */
  Error = 'ERROR',
  /** The scan encountered an error and should not be retried */
  NonRetryableError = 'NON_RETRYABLE_ERROR',
  /** Only applies to Sampling or Classification phase - either Sampling or Classification is not necessary due to the type of scan */
  Skipped = 'SKIPPED',
}

/** Status of a disco class scan run */
export enum ScanRunStatus {
  /** The scan run has finished running successfully */
  Success = 'SUCCESS',
  /** The scan run has failed */
  Error = 'ERROR',
}

/**
 * The type of entity that is being scanned.
 */
export enum ScanEntityType {
  /** The scan entity type */
  Scan = 'SCAN',
  /** The scan run entity type */
  ScanRun = 'SCAN_RUN',
}
